import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IEmployee } from 'src/app/employee/employee';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  private _url: string = environment.api_url;
  constructor(private _http: HttpClient) { }

  addEmployee(employee: IEmployee): Observable<IEmployee>{
    let httpheaders = new HttpHeaders().set('Content-Type','application/Json');
    let options = {
      headers: httpheaders
    };
    return this._http.post<IEmployee>(this._url+'/addEmployee.php',employee, options);
  }

  getEmployee(id:number){
    return this._http.get<IEmployee[]>(this._url+'/eachEmployee.php?id='+id);
  }

  updateEmployee(employee: IEmployee){
    return this._http.put(this._url+'/updateEmployee.php?id='+employee.excelUploadId, employee);
  }
}
